var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{attrs:{"colspan":_vm.cols}},[_c('span',{staticStyle:{"display":"grid"}},[(_vm.subtitle)?_c('span',{staticClass:"font-weight-bold",staticStyle:{"font-size":"0.7em"}},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e(),_c('span',{staticClass:"font-weight-bold font-size-85"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }